export const testDomains = [
  'mms3-test.ub.tu-dortmund.de/',
  'bibliographie-test.ub.rub.de'
];
